import React from 'react';
import { Input, Button, Form, Select } from 'antd';
import 'pages/dashboard/user/changeProfileUser.css';
import { useNavigate } from 'react-router-dom';
import { useGetUserProfileApi, useUpdateUserApi } from './useUserApi';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import GlobalStore from 'stores/globalStore';
import SelectArrow from 'assets/img/forms-select-arrow.svg';

interface dataForm {
  username: string;
  phone: string;
  date_of_birth: string;
  address: string;
}

const ChangeProfileUser: React.FC = () => {
  const [form] = Form.useForm();
  const { Option } = Select;
  let navigate = useNavigate();
  const { update } = useUpdateUserApi();
  const { profileObject } = useGetUserProfileApi();
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  const onUpdateUser = (values: any) => {
    const dataForm: dataForm = {
      username: values.username,
      phone: values.phone,
      date_of_birth:
        values.birthyear + '-' + values.birthmonth + '-' + values.birthday,
      address: values.address
    };
    update(dataForm);
  };

  const getDateOfBirth = (date: string, part: string) => {
    // 2006-10-25
    if (!date || date.length !== 10) {
      return;
    }
    switch (part) {
      case 'day':
        return date.slice(8, 10);
      case 'month':
        return date.slice(5, 7);
      case 'year':
        return date.slice(0, 4);
    }
  };

  return (
    <div className="redeem-code edit-profile">
       {currentLanguage === 'ja' ? (<Helmet>
        <title>プロフィールを編集 - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak アカウントのプロフィール情報を編集します。ユーザー名・電話番号・メールアドレス・生年月日・住所を更新できます。"
        />
      </Helmet>) :
      <Helmet>
        <title>Profile Update - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App user profile update for web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>}
      <h2>{t('profile.update_profile')}</h2>
      <div className="form-edit">
        {profileObject && (
          <Form
            wrapperCol={{ span: 24 }}
            labelCol={{ span: 8 }}
            layout="horizontal"
            colon={false}
            form={form}
            initialValues={{
              layout: 'horizontal',
              username: profileObject?.data?.username,
              phone: profileObject?.data?.phone,
              address: profileObject?.data?.address,
              birthday: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'day'
              ),
              birthmonth: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'month'
              ),
              birthyear: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'year'
              )
            }}
            onFinish={onUpdateUser}
          >
            <Form.Item label={t('profile.user_name')} name="username">
              <Input
                style={{ height: '50px' }}
                placeholder={t('profile.full_name')}
              />
            </Form.Item>

            <Form.Item
              label={t('profile.phone_number')}
              name="phone"
              rules={[
                {
                  pattern: new RegExp(
                    /^(\+81|0)\d{9,10}$/
                  ),
                  message: '電話番号が正しくありません'
                }
              ]}
            >
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder="09012345678"
              />
            </Form.Item>

            <Form.Item label={t('profile.date_of_birth')}>
              <div className="date-of-birth">
                <Form.Item
                  className="birthday-day"
                  name="birthday"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/0[0-9]|1[0-9]|2[0-9]|3[0-1]/),
                      message: '日が正しくありません'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    name="BirthDay"
                    type="text"
                    placeholder="01"
                    maxLength={2}
                  />
                </Form.Item>
                <Form.Item 
                  name="birthmonth" 
                  className="birthday-month" 
                  rules={[
                    {
                      required: true,
                      message: '月が正しくありません'
                    }
                  ]}>
                  <Select
                    size="large"
                    style={{ height: '50px' }}
                    suffixIcon={<img src={SelectArrow} alt="" />}
                  >
                    <Option value="01">1月</Option>
                    <Option value="02">2月</Option>
                    <Option value="03">3月</Option>
                    <Option value="04">4月</Option>
                    <Option value="05">5月</Option>
                    <Option value="06">6月</Option>
                    <Option value="07">7月</Option>
                    <Option value="08">8月</Option>
                    <Option value="09">9月</Option>
                    <Option value="10">10月</Option>
                    <Option value="11">11月</Option>
                    <Option value="12">12月</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  className="birthday-year"
                  name="birthyear"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^(19|20)\d{2}$/),
                      message: '年が正しくありません'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    id="BirthDayYear"
                    type="text"
                    placeholder="1997"
                    maxLength={4}
                  ></Input>
                </Form.Item>
              </div>
            </Form.Item>

            <Form.Item
              className="form-item-address"
              label={t('profile.address')}
              name="address"
            >
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder="住所"
              />
            </Form.Item>
            <div className="form-footer">
              <Button
                type="primary"
                htmlType="button"
                className="form-btn btn_cancle"
                onClick={() => navigate('/')}
              >
                {t('profile.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="form-btn btn_submit"
                // loading={isLoading}
              >
                {t('profile.save_profile')}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ChangeProfileUser;
